module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_import_dress-d01f04333e18429947b162344fd45c1e.png";